module.exports = __webpack_public_path__ + "img/ico-ticket.1010e884.png";